export default __webpack_public_path__ + "static/media/no-result.d49f8301.gif";